"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxRegime = exports.ExpenseSource = exports.ExpenseKind = exports.BankTxDirection = exports.BankTxStatus = exports.EfacturaStatus = exports.PaymentMethod = exports.SeriesDocType = exports.ClientKind = exports.SubStatus = exports.SubFrequency = exports.VatCategoryCode = exports.VatCategory = exports.PaymentStatus = exports.InvoiceKind = exports.InvoiceStatus = void 0;
exports.InvoiceStatus = {
    DRAFT: 'DRAFT',
    ISSUED: 'ISSUED',
    CANCELLED: 'CANCELLED',
};
exports.InvoiceKind = {
    STANDARD: 'STANDARD',
    STORNO: 'STORNO',
    PROFORMA: 'PROFORMA',
};
exports.PaymentStatus = {
    UNPAID: 'UNPAID',
    PARTIAL: 'PARTIAL',
    PAID: 'PAID',
};
exports.VatCategory = {
    STANDARD: 'STANDARD',
    REDUCED: 'REDUCED',
    SUPER_REDUCED: 'SUPER_REDUCED',
};
exports.VatCategoryCode = {
    S: 'S',
    Z: 'Z',
    E: 'E',
    AE: 'AE',
    O: 'O',
};
exports.SubFrequency = {
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    ANNUAL: 'ANNUAL',
};
exports.SubStatus = {
    ACTIVE: 'ACTIVE',
    PAUSED: 'PAUSED',
    ENDED: 'ENDED',
};
exports.ClientKind = {
    COMPANY: 'COMPANY',
    INDIVIDUAL: 'INDIVIDUAL',
};
exports.SeriesDocType = {
    INVOICE: 'INVOICE',
    PROFORMA: 'PROFORMA',
};
exports.PaymentMethod = {
    BANK: 'BANK',
    CASH: 'CASH',
    CARD: 'CARD',
    COMPENSATION: 'COMPENSATION',
    OTHER: 'OTHER',
};
exports.EfacturaStatus = {
    NOT_APPLICABLE: 'NOT_APPLICABLE',
    PENDING: 'PENDING',
    UPLOADED: 'UPLOADED',
    VALIDATED: 'VALIDATED',
    REJECTED: 'REJECTED',
    ERROR: 'ERROR',
};
exports.BankTxStatus = {
    MATCHED: 'MATCHED',
    UNMATCHED: 'UNMATCHED',
    IGNORED: 'IGNORED',
};
exports.BankTxDirection = {
    CREDIT: 'CREDIT',
    DEBIT: 'DEBIT',
};
exports.ExpenseKind = {
    INVOICE: 'INVOICE',
    RECEIPT: 'RECEIPT',
    OTHER: 'OTHER',
};
exports.ExpenseSource = {
    MANUAL: 'MANUAL',
    SPV: 'SPV',
    SMARTBILL: 'SMARTBILL',
    BANK: 'BANK',
};
exports.TaxRegime = {
    /** Microîntreprindere, impozit 1% pe venit. */
    MICRO_1: 'MICRO_1',
    /** Microîntreprindere, impozit 3% pe venit. */
    MICRO_3: 'MICRO_3',
    /** Impozit pe profit 16%. */
    PROFIT_16: 'PROFIT_16',
};
